<template>
  <aside>
    <header class="mb-3">
      <div class="mb-3 d-flex">
        <search-input v-model="search" class="flex-grow-1"/>

        <b-button
          :title="$t('Create new user')"
          :to="{ name: 'users.create' }"
          class="ml-3"
          variant="primary"
        >
          <fa :title="$t('Create new user')" icon="plus"/>
        </b-button>
      </div>

      <b-form-checkbox
        v-if="$gate.allow('restore', 'user')"
        v-model="params.show_deleted"
        unchecked-value="0"
        value="1"
      >
        {{ $t('Show deleted') }}
      </b-form-checkbox>

    </header>

    <b-list-group>
      <users-list-item
        v-for="(user, index) in items"
        :key="user.id"
        v-model="items[index]"
      >
      </users-list-item>
    </b-list-group>

    <b-pagination
      v-if="showPagination"
      v-model="currentPage"
      :per-page="perPage"
      :total-rows="totalRows"
      align="fill"
      limit="3"
    />

    <div v-show="pending" class="text-center mt-1">
      <b-spinner/>
    </div>
  </aside>
</template>
<script>
import fetchPaginatedData from '@/mixins/fetchPaginatedData';
import SearchInput from "@/components/SeachInput";
import crudListener from "@/mixins/crudListener";
import UsersListItem from "@/components/users/UsersListItem.vue";

export default {
  name: 'Users',
  components: {UsersListItem, SearchInput},
  mixins: [fetchPaginatedData, crudListener],
  computed: {
    resourceName() {
      return 'users'
    },
  },

  methods: {
    handleRestore() {
      this.restoring = true;

      this.axios.post(`/api/projects/${this.project.id}/restore`).then(({data}) => {
        this.project = data;
      }).catch(e => e.respone || throw e)
          .finally(() => this.restoring = false)
    }
  }
}
</script>
